import { ApiEndpointBuilder } from "@/services/api/types";
import { invitationsApi } from "@/store/invitations/endpoints/index.ts";

const deleteInvitationUserEndpoint = (builder: ApiEndpointBuilder) => {
  return builder.mutation<string, Request>({
    query: ({ invitationId }) => ({
      url: `/invitations/${invitationId}`,
      method: "DELETE",
    }),

    async onQueryStarted(args, { dispatch, queryFulfilled }) {
      // Update cached data by removing the deleted invitation
      const patchResult = dispatch(
        invitationsApi.util.updateQueryData("searchInvitationsUsers", {}, draftPosts => {
          return {
            ...draftPosts,
            data: [
              ...draftPosts?.data.filter(obj => {
                return obj.id != args?.invitationId;
              }),
            ],
          };
        })
      );

      try {
        await queryFulfilled;
      } catch (err) {
        patchResult.undo();
      }
    },
  });
};

type Request = {
  invitationId: string;
};

export default deleteInvitationUserEndpoint;
